import { css } from '@emotion/css';
import colors from '@/theme/colors';
import { pxToRem } from '@/utils';

const styles = {
  flyerCard: css`
    position: relative;
    display: flex;
    flex-direction: column;
    padding: 2px;
    img {
      width: 100%;
      /* height: 209px; */
      border-radius: 10px;
      border: 1px solid #f5f5f5;
    }
  `,
  flyerContent: css`
    display: flex;
    flex-direction: row;
    align-items: center;
  `,
  flyerTitle: css`
    /* font-size: 13px; */
    width: 90%;
    /* color: ${colors.prussian};
    font-weight: 700; */
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  `,
  favoriteIcon: css`
    color: ${colors.prussian};
  `,
  favoriteIconSelected: css`
    color: ${colors.gold};
  `,
  schoolIconContainer: css`
    position: relative;
    width: ${pxToRem(60)};
  `,
  viewedTag: css`
    position: absolute;
    right: 8px;
    top: 8px;
  `,
  schoolIcon: css`
    display: flex;
    justify-content: center;
    position: absolute;
    width: ${pxToRem(32)};
    height: ${pxToRem(20)};
    padding: 2px 8px;
    top: 8px;
    right: 8px;
    background-color: ${colors.prussian300};
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.3),
      0 4px 8px 3px rgba(0, 0, 0, 0.15);
    border-radius: 50px;
    color: ${colors.prussian};
  `,
  weekText: css`
    font-size: ${pxToRem(14)};
    color: ${colors.prussian};
    padding-bottom: 8px;
  `,
  loader: css`
    min-height: ${pxToRem(120)};;
    /* display: flex; */
    /* flex: 1; */
    /* flex: 0 0 100%; */
    /* flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 120px; */
  `,
  inactiveFlyer: css`
    opacity: 70%;
  `,
  readFlyer: css`
    opacity: 80%;
  `,
  tagContainer: css`
    padding-top: 8px;
  `,
  flyerDescription: css`
    position: absolute;
    left: -10000px;
    top: auto;
    width: 1px;
    height: 1px;
    overflow: hidden;
  `
};

export default styles;
